module.exports = __webpack_public_path__ + "img/interactions.f7f543c4.png";